export enum MedicalAttachmentEnum {
  MEDICAL_CERTIFICATE = 'diagnosticReport',
  PRESCRIPTION = 'medicalRequest',
  LABORATORY_REQUEST = 'laboratoryServiceRequest',
}
